module.exports = __webpack_public_path__ + "static/media/door_orange.e037edb9.jpg";